import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            title: "RMZ Asesores",
            metaTags: [
                {
                    name: "description",
                    content: "Sitio web de RMZ Asesores"
                },
                {
                    property: "og:description",
                    content: "Sitio web de RMZ Asesores"
                }
            ]
        }
    },
    {
        path: "/nosotros",
        name: "Nosotros",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Nosotros.vue"),
        meta: {
            title: "RMZ Asesores - Nosotros",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Nosotros"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Nosotros"
                }
            ]
        }
    },
    {
        path: "/administracion-de-riesgos",
        name: "Administración de riesgos",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Administracion-de-riesgos.vue"
            ),
        meta: {
            title: "RMZ Asesores - Administración de riesgos",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Administración de riesgos"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Administración de riesgos"
                }
            ]
        }
    },
    {
        path: "/asesoria-en-siniestros",
        name: "Asesoría en siniestros",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Asesoria-en-siniestros.vue"
            ),
        meta: {
            title: "RMZ Asesores - Asesoría en siniestros",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Asesoría en siniestros"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Asesoría en siniestros"
                }
            ]
        }
    },
    {
        path: "/auditoria-en-seguros",
        name: "Auditoría en seguros",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Auditoria-en-seguros.vue"
            ),
        meta: {
            title: "RMZ Asesores - Auditoría en seguros",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Auditoría en seguros"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Auditoría en seguros"
                }
            ]
        }
    },
    {
        path: "/seguros-venta-y-asesoria-individuos",
        name: "Seguros: venta y asesoría individuos y familias",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Seguros-venta-y-asesoria.vue"
            ),
        meta: {
            title: "RMZ Asesores - Seguros: venta y asesoría individuos y familias",
            metaTags: [
                {
                    name: "description",
                    content:
                        "RMZ Asesores - Seguros: venta y asesoría individuos y familias"
                },
                {
                    property: "og:description",
                    content:
                        "RMZ Asesores - Seguros: venta y asesoría individuos y familias"
                }
            ]
        }
    },
    {
        path: "/seguros-venta-y-asesoria-profesionales",
        name: "Seguros: venta y asesoría profesionales independientes y pymes",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Seguros-venta-y-asesoria-profesionales.vue"
            ),
        meta: {
            title:
                "RMZ Asesores - Seguros: venta y asesoría profesionales independientes y pymes",
            metaTags: [
                {
                    name: "description",
                    content:
                        "RMZ Asesores - Seguros: venta y asesoría profesionales independientes y pymes"
                },
                {
                    property: "og:description",
                    content:
                        "RMZ Asesores - Seguros: venta y asesoría profesionales independientes y pymes"
                }
            ]
        }
    },
    {
        path: "/seguros-venta-y-asesoria-empresas",
        name: "Seguros: venta y asesoría empresas y corporativos",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Seguros-venta-y-asesoria-empresas.vue"
            ),
        meta: {
            title: "RMZ Asesores - Seguros: venta y asesoría empresas y corporativos",
            metaTags: [
                {
                    name: "description",
                    content:
                        "RMZ Asesores - Seguros: venta y asesoría empresas y corporativos"
                },
                {
                    property: "og:description",
                    content:
                        "RMZ Asesores - Seguros: venta y asesoría empresas y corporativos"
                }
            ]
        }
    },
    {
        path: "/aqui-estamos-preparados",
        name: "Aquí estamos preparados",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Aqui-estamos-preparados.vue"
            ),
        meta: {
            title: "RMZ Asesores - Aquí estamos preparados",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Aquí estamos preparados"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Aquí estamos preparados"
                }
            ]
        }
    },
    {
        path: "/diagnostico",
        name: "Diagnóstico",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Diagnostico.vue"),
        meta: {
            title: "RMZ Asesores - Diagnóstico",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Diagnóstico"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Diagnóstico"
                }
            ]
        }
    },
    {
        path: "/aviso-de-privacidad",
        name: "Aviso de Privacidad",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
        /* webpackChunkName: "about" */ "../views/Aviso-de-privacidad.vue"
            ),
        meta: {
            title: "RMZ Asesores - Aviso de Privacidad",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Aviso de Privacidad"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Aviso de Privacidad"
                }
            ]
        }
    },
    {
        path: "/informacion-legal",
        name: "Información Legal",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Informacion-legal.vue"),
        meta: {
            title: "RMZ Asesores - Información Legal",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Información Legal"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Información Legal"
                }
            ]
        }
    },
    {
        path: "/cookies",
        name: "Uso de de las Cookies",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Cookies.vue"),
        meta: {
            title: "RMZ Asesores - Uso de las Cookies",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Uso de las Cookies"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Uso de las Cookies"
                }
            ]
        }
    },
    {
        path: "/terminosycondiciones",
        name: "Términos y condiciones",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Terminos.vue"),
        meta: {
            title: "RMZ Asesores - Términos y Condiciones",
            metaTags: [
                {
                    name: "description",
                    content: "RMZ Asesores - Términos y Condiciones"
                },
                {
                    property: "og:description",
                    content: "RMZ Asesores - Términos y Condiciones"
                }
            ]
        }
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            console.log(to);
            console.log(from);
            let ex = [
                "/seguros-venta-y-asesoria-individuos",
                "/seguros-venta-y-asesoria-profesionales",
                "/seguros-venta-y-asesoria-empresas"
            ];
            if (!(ex.includes(to.path) && ex.includes(from.path))) {
                return { x: 0, y: 0 };
            }
        }
    }
});

export default router;
const DEFAULT_TITLE = "RMZ Asesores";
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    console.log(from);
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});
